<template>
  <div class="cfs-field d-flex flex-column" :class="{ 'static-bg': staticBg }">
    <p class="input-title px-1 pb-1" :class="{ disabled }">
      {{ label }} <span v-if="optional" class="text-blue-havelock">(Optional)</span>
    </p>
    <v-file-input
      ref="outer"
      v-bind="{ ...$attrs, ...$props }"
      v-model="model"
      class="cfs-file-field"
      dense
      outlined
      :placeholder="placeholder || $t('UploadFiles')"
      :label="null"
      :prepend-icon="null"
    >
      <template #append>
        <v-btn class="mb-1" small color="primary" dark @click="outerClickHandler">
          {{ $t('BrowseFile') }}
        </v-btn>
      </template>
    </v-file-input>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useToast } from '@/composables/useToast';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Object, File, Array],
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    optional: {
      type: Boolean,
      default: false,
    },
    /**when set to false fills input with application background solid color instead of inherited one.
     * I.e. removes transparency from input*/
    staticBg: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const toast = useToast();
    const outer = ref();

    const model = computed({
      get() {
        if (!props.data) {
          return null;
        }
        if (Array.isArray(props.data)) {
          return props.data;
        }
        const dataKeys = Object.keys(props.data);

        if (!dataKeys.length) {
          return props.data;
        }
        return !(props.data instanceof File)
          ? { ...props.data, name: props.data.filename }
          : props.data;
      },
      set(value) {
        emit('change', value);
      },
    });

    const outerClickHandler = () => {
      outer.value.$el.querySelector('input').click();
    };

    return { model, outer, outerClickHandler };
  },
};
</script>
